import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from "./sideBar";
import Header from "../Header/header";

const Layout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  /* ── Offline detection (8.2.4) ── */
  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  return (
    <div
      className="h-screen overflow-hidden overflow-x-hidden"
      style={{ backgroundColor: 'var(--color-bg-secondary)', maxWidth: '100vw' }}
    >
      {/* Skip navigation link (3.2.5) */}
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>

      {/* Offline banner (8.2.4) */}
      {isOffline && (
        <div className="offline-banner" role="alert">
          <span>&#9888;</span> You are offline. Some data may be outdated.
        </div>
      )}

      <Sidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
      />

      {/* Main content wrapper */}
      <div
        className={`
          flex flex-col h-full transition-all duration-300
          pl-0
          ${isCollapsed ? 'lg:pl-20' : 'lg:pl-64'}
        `}
      >
        <Header
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
        />

        <main
          id="main-content"
          className="flex-1 overflow-y-auto overflow-x-hidden min-w-0"
          style={{ backgroundColor: 'var(--color-bg-primary)' }}
        >
          {/* Aria-live region for dynamic content announcements (3.2.2) */}
          <div aria-live="polite" aria-atomic="true" className="sr-only" id="live-announcements" />
          <Outlet />
        </main>
      </div>
    </div>
  );
};


export default Layout;